import { Permission, PermissionAction } from 'generated/openApi';

export interface CardPermissionRequirement {
    permission: Permission;
    action: PermissionAction;
}

export type CardId = number;

export interface DashboardCardConfig {
    id: CardId;
    name: string;
    description?: string;
    icon?: string;
    enabled: boolean;
    displayOrder: number;
    category?: string;
    isNew?: boolean;
    requiredPermissions?: CardPermissionRequirement[];
}

export interface DashboardPreferences {
    cards: DashboardCardConfig[];
    lastUpdated: Date;
}

export enum LkDashboardCardId {
    ServiceChart = 1,
    ServiceTable = 2,
    MatchChart = 3,
    MatchTable = 4,
    Notifications = 5,
    TotalStudents = 6,
    SchoolEnrollment = 7,
    FafsaChart = 8,
    FafsaTable = 9,
    EndReasonTypeTable = 10,
    EndReasonTypeChart = 11,
    ParticipantsChart = 12,
    ParticipantsTable = 13,
    GenderChart = 14,
    GenderTable = 15,
    EligibilityChart = 16,
    EligibilityTable = 17,
    RaceChart = 18,
    RaceTable = 19,
    EthnicityChart = 20,
    EthnicityTable = 21,
    IEPChart = 22,
    IEPTable = 23,
    LEPChart = 24,
    LEPTable = 25,
}